import React from "react";
import { Accordion, Card, ListGroup } from "react-bootstrap";
import { FaInfoCircle, FaRegHandPointRight } from "react-icons/fa";

const SeasonRulesCard: React.FC = () => {
	return (
		<Accordion className="mb-3 bg-secondary text-white border-0 shadow">
			<Accordion.Item eventKey="0" className="shadow border-0">
				<Accordion.Header className="bg-secondary text-white">
					<FaInfoCircle className="me-2 mb-1" />
					<span className="fs-3 fw-bold">Season Rules</span>
				</Accordion.Header>
				<Accordion.Body
					className="bg-secondary text-white"
					style={{ fontSize: "0.8rem" }}
				>
					<Card.Text>
						The following rules apply throughout the racing season:
					</Card.Text>

					<ListGroup variant="flush" className="text-white bg-secondary">
						<ListGroup.Item className="bg-secondary text-white border-secondary">
							<FaRegHandPointRight className="me-2" />
							<strong>Team Changes:</strong> You can modify your team as often
							as you would like throughout the season.
						</ListGroup.Item>

						<ListGroup.Item className="bg-secondary text-white border-secondary">
							<FaRegHandPointRight className="me-2" />
							<strong>Team Snapshots:</strong> Snapshots of your team are taken
							directly before qualifying. Any changes made to your team during
							an event will not be reflected in the event results.
						</ListGroup.Item>

						<ListGroup.Item className="bg-secondary text-white border-secondary">
							<FaRegHandPointRight className="me-2" />
							<strong>Rider Values:</strong> Rider values remain static for the
							entire season. If a rider's value is adjusted due to being
							seriously mis-valued, it will not affect your existing team.
						</ListGroup.Item>

						<ListGroup.Item className="bg-secondary text-white border-secondary">
							<FaRegHandPointRight className="me-2" />
							<strong>Teams Per User:</strong> Each user gets a single team per
							series/discipline, but can enroll in as many leagues as they would
							like with that team.
						</ListGroup.Item>
					</ListGroup>

					<Card.Text className="mt-3 p-2 bg-dark rounded">
						<strong>Note:</strong> Some riders may be missing and will be added
						as they are accounted for on the results sheet. Currently, all
						riders are in the elite field, not the junior field.
					</Card.Text>
				</Accordion.Body>
			</Accordion.Item>
		</Accordion>
	);
};

export default SeasonRulesCard;
